import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeTransfer',
})

/**
 * 시간정보 변환.
 */
export class timeTransferPipe implements PipeTransform {

  transform(val: any, args?: any): string {
    const arrTime = [];
    const hours = Math.floor(val / 60);
    const minute = val % 60;
    if (hours > 0) {
      arrTime.push(hours + '시간');
    }
    if (minute) {
      arrTime.push(minute + '분');
    }

    return arrTime.join(' ');
  }
}
